import { userService } from '@/services/UserService';
import { ApolloQueryResult } from 'apollo-client';
import {
  loginInit,
  loginInit_currentOperator,
  logoutUser,
  OperatorOrganizationInput
} from '@/types/graphql/schemaTypes';
import { UserState, RootState } from '@/types/store';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import { authenticationService } from '@/services/AuthenticationService';
import { FetchResult } from 'apollo-link';
import get from 'lodash/get';
import i18n from '@/plugins/i18n';

// initial state
const state: UserState = {
  profile: null,
  hasUnreadNotifications: false,
  updatedProfile: null,
  notifications: []
};

// getters
const getters: GetterTree<UserState, RootState> = {
  currentUser() {
    return state.profile;
  }
};

// actions
const actions: ActionTree<UserState, RootState> = {
  async logout({ commit }): Promise<void> {
    await authenticationService.logout().then((response: FetchResult<logoutUser>): void => {
      if (get(response, 'data.logoutUser')) {
        commit('clearUserStore');
      }
    });
  },

  // TODO: add shipmentcountupdate action ?????
  async userInit({ commit, dispatch }): Promise<void> {
    userService.init().then((response: ApolloQueryResult<loginInit>): void => {
      commit('setCurrentUser', response.data.currentOperator);
    });
  },

  async emptyUserStore({ commit }): Promise<void> {
    commit('clearUserStore');
  },

  async updateOrganization({ dispatch, commit }, args: OperatorOrganizationInput): Promise<void> {
    userService.updateOrganization(args).then(() => {
      commit('Alert/addAlert', {
        type: 'success',
        message: i18n.t('success.updated'),
        time: 5000
      }, { root: true });
    });
  },

  async updateProfile({ commit }) {
    commit('userInit');
  }
};

// mutations
const mutations: MutationTree<UserState> = {
  setCurrentUser(userState, profile: loginInit_currentOperator) {
    userState.profile = profile;
    userState.hasUnreadNotifications = profile.hasUnreadNotifications || false;
  },

  clearUserStore(userState) {
    userState.profile = null;
  },

  readNotifications(userState) {
    userState.hasUnreadNotifications = false;
  },

  setUnreadNotification(userState, hasUnreadNotifications: boolean) {
    userState.hasUnreadNotifications = !!hasUnreadNotifications;
  },

  clearUpdateProfile(userState) {
    userState.updatedProfile = null;
  }
};

export const user: Module<UserState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
